import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

type LogClickFilterParams = {
  selectedItem?: string;
  itemLogging?: AnyObject;
  /** 캐러셀 임베드 여부 — iOS RadioFilterGroupReactor.isEmbedded / Android 캐러셀 State 대응. true면 CLICK_CAROUSEL_FILTER 계열 */
  isEmbedded?: boolean;
  /** sub_radio 그룹 여부 */
  isSubRadio?: boolean;
};

export const useLogClickFilter = (logging: AnyObject) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({
      selectedItem,
      itemLogging,
      isEmbedded = false,
      isSubRadio = false,
    }: LogClickFilterParams) => {
      const eventName = isEmbedded
        ? isSubRadio
          ? 'CLICK_CAROUSEL_SUB_FILTER'
          : 'CLICK_CAROUSEL_FILTER'
        : isSubRadio
          ? 'CLICK_SUB_FILTER'
          : 'CLICK_FILTER';
      logAnalyticsEvent({
        name: eventName,
        ably_only_log: {
          ...logging.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
        analytics: {
          ...logging.analytics,
          ...itemLogging?.analytics,
          ...(selectedItem != null && { SELECTED_ITEM: selectedItem }),
        },
      });
    },
    [logAnalyticsEvent, logging],
  );
};
